import(/* webpackMode: "eager" */ "/app/apps/frontend/app/(dashboard)/account/page.tsx");
